export enum SearchResultType {
  Documents = 'documents',
  Contacts = 'contacts',
}
